import { apiRequest } from "../api/request";
import API_PATHS from "../api/paths";

export async function getSortOrder(storeId) {
    return await apiRequest({
        url: API_PATHS.getSortOrder(storeId),
        method: "GET",
    });
}

export async function updateSortOrder(storeId, items) {
    return await apiRequest({
        url: API_PATHS.updateSortOrder(storeId),
        method: "PUT",
        data: items,
    });
}
